import React, { useState, useEffect } from 'react';
import {FormComponent} from '@formbird/types';
import { convertToCustomElement } from '../utils/CustomElementWrapper';

import './style.less';

const CrmPanelIconsComponent = ({
  _,
  fieldValue,
  template,
  fieldName,
  formParameters,
  key,
  responsiveLayouts,
  message,
  componentDefinition
}) => {
  useEffect(() => {
    console.warn( componentDefinition )
    let genIcon = ( panel ) => {
      let title = panel.innerText;
      let icon = componentDefinition.iconNames[title];

      if ( icon !== undefined )
        return "<div class=\"crm-panel-icon-background\"> <i class=\"" + icon.icon + " crm-panel-icon\" /></div>"
      else return "<i></i>";
    }

    let headings = Array.prototype.slice.call( document.getElementsByClassName( "panel-heading" ) );
    headings.forEach( x => x.insertAdjacentHTML( "afterbegin", genIcon( x ) ) )

  }, []);
  
  // we want to add CrmPanelIcon to all panel-heading tagged divs
  return (
    <div id="IconDiv"></div> 
  );
};

// register the component as a custom element so it can be shown in formbird
convertToCustomElement('crm-panel-icons', CrmPanelIconsComponent);

export default CrmPanelIconsComponent;
